import clsx from "clsx";
import { ElementType, PropsWithChildren } from "react";
import { PolymorphicComponent } from "../../../../PolymorphicComponent";

export type Props = PropsWithChildren<{
  className?: string;
  dataTestId?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  as?: ElementType<any>;
}>;

export function ModalBody({
  as = "div",
  children,
  className,
  dataTestId,
}: Props) {
  return (
    <PolymorphicComponent
      as={as}
      className={clsx(
        "font-roobert font-normal leading-140 text-[16px] md:text-md",
        className,
      )}
      data-testid={dataTestId}
    >
      {children}
    </PolymorphicComponent>
  );
}
